import { createRouter, createWebHistory } from 'vue-router'

// 导入页面组件
const Home = () => import('../views/Home.vue')
const Ai = () => import('../views/Ai.vue')
const Hemiao = () => import('../views/Hemiao.vue')
const Hongyun = () => import('../views/Hongyun.vue')
const HeXiao = () => import('../views/HeXiao.vue')
const About = () => import('../views/About.vue')
const NotFound = () => import('../views/NotFound.vue')

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '禾苗-让数据将经营变得更高效'
      }
    },
    {
      path: '/ai',
      name: 'Ai',
      component: Ai,
      meta: {
        title: 'AI人脸识别'
      }
    },
    {
      path: '/hemiao',
      name: 'Hemiao',
      component: Hemiao,
      meta: {
        title: '禾苗商城'
      }
    },
    {
      path: '/hongyun',
      name: 'Hongyun',
      component: Hongyun,
      meta: {
        title: 'HONG云'
      }
    },
    {
      path: '/hexiao',
      name: 'HeXiao',
      component: HeXiao,
      meta: {
        title: '禾销 - 智能营销管理系统'
      }
    },
    // about相关路由
    {
      path: '/about/intro',
      name: 'AboutIntro',
      component: About,
      meta: {
        title: '关于我们 - 禾苗（武汉）信息技术有限公司'
      }
    },
    { path: '/about/hxnews',
      name: 'AboutNews',
      component: About,
      meta: {
        title: '新闻中心 - 禾苗（武汉）信息技术有限公司'
      }
    },
    { path: '/about/news/:id',
      name: 'NewsDetail',
      component: () => import('../views/about/NewsDetail.vue'),
      meta: {
        title: '新闻详情 - 禾苗（武汉）信息技术有限公司'
      }
    },
    {
      path: '/about/jobs',
      name: 'AboutJobs',
      component: About,
      meta: {
        title: '工作机会 - 禾苗（武汉）信息技术有限公司'
      }
    },
    // 404页面路由
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: '页面未找到 - 禾苗（武汉）信息技术有限公司'
      }
    }
  ],
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由前置守卫，设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router